// removed by extract-text-webpack-plugin
module.exports = {"Tip":"TipRightClick__Tip__-hash-base-64-5-","fadeInAndOut":"TipRightClick__fadeInAndOut__-hash-base-64-5-"};


//////////////////
// WEBPACK FOOTER
// ./src/components/presentational/TipRightClick/TipRightClick.scss
// module id = 193
// module chunks = 0